import RecruitmentStory from 'routes/NewMemberAnalytics/RecruitmentStory/RecruitmentStory';

export default RecruitmentStory;
